import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const STORAGE_KEY = "giant-fitness-cookies-accepted";

export function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const accepted = localStorage.getItem(STORAGE_KEY);
    if (!accepted) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-20 md:bottom-0 left-0 right-0 z-[55] px-4 py-3 bg-gray-900 text-gray-200 text-sm shadow-lg flex flex-wrap items-center justify-center gap-x-4 gap-y-2"
      role="dialog"
      aria-label="Cookie notice"
    >
      <span>
        We use cookies to improve your experience. By continuing you agree to our{" "}
        <Link to="/privacy" className="text-brand-orange hover:underline">
          Privacy Policy
        </Link>
        .
      </span>
      <Button
        size="sm"
        variant="secondary"
        className="bg-white text-gray-900 hover:bg-gray-100 shrink-0"
        onClick={accept}
      >
        Got it
      </Button>
    </div>
  );
}

export default CookieNotice;
